import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoAuthService } from '@app/cognito-auth.service';

@Component({
    template: `<div>{{error}}</div>`
})
export class CognitoCallbackComponent implements OnInit {

    error: string;

    constructor(
        private router: Router,
        private cognitoAuth: CognitoAuthService
    ) {
        //
    }

    async ngOnInit(): Promise<void> {
        try {
            await this.cognitoAuth.logInWithCode();
            this.cognitoAuth.redirectToOriginalUrl();
        }
        catch (error) {
            this.error = error.toString();
        }
    }
}
